import { useEffect } from "react";
import { langPair } from "@/utils/paths";

const BASE = "https://swisspaservice.ch";

export const SEO = ({ title, description, path = "/", jsonLd }) => {
  useEffect(() => {
    document.title = title;
    const set = (sel, val) => {
      const el = document.querySelector(sel);
      if (el) el.setAttribute("content", val);
    };
    set('meta[name="description"]', description);
    set('meta[property="og:title"]', title);
    set('meta[property="og:description"]', description);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${BASE}${path}`);

    document.querySelectorAll("link[data-hreflang-dynamic]").forEach((el) => el.remove());
    const pair = langPair(path);
    [
      { hreflang: "de-ch", href: `${BASE}${pair.de}` },
      { hreflang: "en", href: `${BASE}${pair.en}` },
      { hreflang: "x-default", href: `${BASE}${pair.de}` },
    ].forEach(({ hreflang, href }) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = hreflang;
      link.href = href;
      link.setAttribute("data-hreflang-dynamic", "true");
      document.head.appendChild(link);
    });

    if (jsonLd) {
      const old = document.getElementById("page-jsonld");
      if (old) old.remove();
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      const s = document.getElementById("page-jsonld");
      if (s) s.remove();
      document.querySelectorAll("link[data-hreflang-dynamic]").forEach((el) => el.remove());
    };
  }, [title, description, path, jsonLd]);
  return null;
};
